
import { NotificationState } from './types';
import getters from './getters';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import { Module } from 'vuex';
import { RootState } from '../types';


export const notification: Module<NotificationState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};




